import InvoicesPageBody from "../components/invoicePage/InvoicesPageBody";

const InvoicesPage = () => {
    return(
        <InvoicesPageBody/>
    )
}

export default InvoicesPage;